// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Pay_loadingContainer__drbIY"};